import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive } from "vue";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import AgsDataService from "@/services/AgsDataService";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/agsrs/Loading.vue";

import * as bootstrap from "bootstrap";
import Compressor from "compressorjs";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const vinNo = ref("");
const file = reactive([]);
const filename = ref("選択されていません");
const url = ref("");
const compressedFile = reactive([]);
const isLoading = ref(false);
const vinFlag = ref(false);
const ocrError = ref(false);
const nextButtonFlag = ref(false);
const selectFileFlag = ref(false);

const fullWidth2HalfWidth = () => {
  return vinNo.value.replace(/[^ -~。-゜]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}

const selectedFile = (event) => {
  compressedFile.value = [];
  isLoading.value = true;
  ocrError.value = false;
  selectFileFlag.value = true;
  nextButtonFlag.value = false;
  event.preventDefault();
  file.value = event.target.files[0];
  if (file.value) {
    url.value = URL.createObjectURL(file.value);
    filename.value = "選択済みです";
    compress(file.value);
  } else {
    url.value = "";
    filename.value = "選択されていません";
    isLoading.value = false;
  }
};

const compress = (file) => {
  const payload: Compressor.Options = {
    quality: 0.7,
    maxWidth: 600,
    maxHeight: 600,
    mimeType: "image/jpeg",
    success(blob: Blob): void {
      compressedFile.value = blob;
      isLoading.value = false;
    },
    error(err: Error): void {
      isLoading.value = false;
      console.log(err.message);
    },
  };
  new Compressor(file, payload);
};

// ファイル送信
const submitPicture = () => {
  isLoading.value = true;
  ocrError.value = false;
  vinFlag.value = false;
  nextButtonFlag.value = false;
  document.getElementById("vinNo").classList.remove("border");
  document.getElementById("vinNo").classList.remove("border-danger");
  document.getElementById("vinNo").classList.remove("border-4");
  const formData = new FormData();
  formData.append("image", compressedFile.value);
  AgsDataService.getVinNoByTextract(formData)
    .then(async (response: ResponseData) => {
      const modal = new bootstrap.Modal(
        document.getElementById("errorModal")
      );
      vinNo.value = response["data"];
      isLoading.value = false;
      modal.show();
    })
    .catch(async (e: Error) => {
      isLoading.value = false;
      ocrError.value = true;
      console.log(e);
    });
};

const submitVinNo = () => {
  vinNo.value = fullWidth2HalfWidth();
  vinNo.value = vinNo.value.toUpperCase();
  if (
    !vinNo.value ||
    vinNo.value.length !== 12 ||
    vinNo.value.substr(0, 1) !== "D" ||
    vinNo.value.indexOf("-") === -1 ||
    vinNo.value.split('-')[1].match(/^[0-9]*$/) === null
  ) {
    vinFlag.value = true;
    const modal = new bootstrap.Modal(document.getElementById("confirmModal"));
    modal.show();
  } else {
    store.dispatch("setVinNo", vinNo.value);
    router.push("/postSerialNumber");
  }
};

const inputFix = () => {
  selectFileFlag.value = false;
  nextButtonFlag.value = false;
  document.getElementById("vinNo").classList.add("border");
  document.getElementById("vinNo").classList.add("border-danger");
  document.getElementById("vinNo").classList.add("border-4");
};

const __returned__ = { router, vinNo, file, filename, url, compressedFile, isLoading, vinFlag, ocrError, nextButtonFlag, selectFileFlag, fullWidth2HalfWidth, selectedFile, compress, submitPicture, submitVinNo, inputFix, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})